import * as React from 'react';

import classnames from 'classnames';

import type {Column} from '../types';

import styles from './table-footer-cell.module.css';

type Props = {
    column: Column;
    isResizable: boolean;
    isCompact: boolean;
    hasCellBorders: boolean;
    children: React.ReactNode;
    shouldFooterAlign?: boolean;
};

export function TableFooterCell(props: Props) {
    const {column, isResizable, isCompact, hasCellBorders, children} = props;
    const {getHeaderProps} = column;

    const isInteger = column.dataType === 'integer';
    const TF = isResizable ? 'div' : 'td';

    const styleNames = classnames(styles['table-footer-cell'], {
        [styles.bordered]: hasCellBorders,
        [styles.compact]: isCompact,
        [styles['data-type--integer']]: isInteger,
        [styles['border--right']]: column.hasRightBorder,
        [styles['align-right']]: props.shouldFooterAlign && column.rightAlign,
        [styles['align-center']]: props.shouldFooterAlign && column.centerAlign,
    });

    return (
        <TF {...getHeaderProps()} className={styleNames}>
            {children}
        </TF>
    );
}
